import '@tamagui/core/reset.css'

import { Button, H3, ListItem, Spinner, Text, YStack } from 'tamagui'
import { useNavigate, useParams } from 'react-router-dom'
import { Header } from '../../components/Header'
import { getMyOrganizations, MyOrganizationsData, OrganizationData } from '../../remote/organizations'
import { useEffect, useState } from 'react'
import { Building, Palmtree } from '@tamagui/lucide-icons'
import { SupplierEditor } from '../../components/SupplierEditor'
import { SupplierAdd } from '../../components/SupplierAdd'

export const Home = () => {
	const navigate = useNavigate()

	const [myOrgs, setMyOrgs] = useState<MyOrganizationsData | null>(null);
	const [isLoaded, setIsLoaded] = useState(false)
	useEffect(() => {
		getMyOrganizations((data, resp) => {
			if (data) {
				setMyOrgs(data);
				setIsLoaded(true);
			} else {
				setMyOrgs(null);
				setIsLoaded(false);
			}
		});
	}, [setMyOrgs, setIsLoaded]);

	return (
	  <>
		<Header/>
		<YStack flex={1} items="flex-start" justify="flex-start" margin='$8'>
			<H3>My organizations</H3>
		  {
			isLoaded && myOrgs
			? <>
				{myOrgs && myOrgs.orgs.length > 0 ? myOrgs.orgs.map((org: OrganizationData) => {
					return (
						<ListItem icon={Building} title={org.name} subTitle={org.email} justify="flex-start">
							<Text>{org.name}</Text>
							<Button marginLeft="auto">Manage suppliers</Button>
							<Button>Manage people</Button>
						</ListItem>
					)
				}) : <Text>You are not part of any organizations!</Text>}
			</>
			: <>
				<Spinner></Spinner>
			</>
		  }
		</YStack>
	  </>
	)
}

export class CreateSupplierPageProps {
	constructor() {
	}
}

export const CreateSupplierPage = (props: CreateSupplierPageProps) => {
	const params = useParams()
	return <SupplierEditor supplierId={undefined} />
}

export class EditSupplierPageProps {
	supplierId: string
	constructor(supplierId: string) {
		this.supplierId = supplierId;
	}
}

export const EditSupplierPage = () => {
	const params = useParams()
	return <SupplierEditor supplierId={params.supplierId} />
}

export class AddSupplierPageProps {
	orgId: string
	constructor(orgId: string) {
		this.orgId = orgId;
	}
}

export const AddSupplierPage = () => {
	const params = useParams()
	if (params.orgId) {
		return <SupplierAdd orgId={params.orgId} />
	} else {
		return <><H3>Bad route</H3></>
	}
}
